const handler = ( $ ) => {
	const lightHoverContainers = document.querySelectorAll( '.light-hover' );

	lightHoverContainers.forEach( ( container ) => {
		container.addEventListener( 'mousemove', ( e ) => {
			const rect = container.getBoundingClientRect();
			const x = e.clientX - rect.left;
			const y = e.clientY - rect.top;
			container.style.setProperty( '--mouse-x', `${ x }px` );
			container.style.setProperty( '--mouse-y', `${ y }px` );
		} );
	} );

	const $grids = $( '.client-logos-grid' );
	$grids.each( function () {
		const $currentGrid = $( this );
		const $currentItems = $currentGrid.find( '.technology-item' );

		let radius = 400;
		if ( $currentGrid.parents( '.get-in-touch-section' ).length > 0 ) {
			radius = 200;
		}

		$currentGrid.on( 'mousemove', function ( e ) {
			$currentGrid.addClass( 'grid-active' );

			const mouseX = e.clientX;
			const mouseY = e.clientY;
			const scrollVal = $( window ).scrollTop();

			$currentItems.each( function () {
				const $item = $( this );
				const offset = $item.offset();

				// Calculate center
				const itemX = offset.left + $item.outerWidth() / 2;
				const itemY = offset.top + $item.outerHeight() / 2 - scrollVal;

				const distance = Math.sqrt(
					Math.pow( mouseX - itemX, 2 ) +
						Math.pow( mouseY - itemY, 2 )
				);

				if ( distance < radius ) {
					$item.addClass( 'neighbor-hover' );
				} else {
					$item.removeClass( 'neighbor-hover' );
				}
			} );
		} );

		$currentGrid.on( 'mouseleave', function () {
			$currentGrid.removeClass( 'grid-active' );
			$currentItems.removeClass( 'neighbor-hover' );
		} );
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
